// extracted by mini-css-extract-plugin
export default {"area":"GeneralInfoPreview_area__CAfvk","areaUnit":"GeneralInfoPreview_areaUnit__d7nJk","value":"GeneralInfoPreview_value__BqGUD"};